/**
 * Device-related models and interfaces
 */

import type { AndroidBuildProto, AndroidCheckinRequest, DeviceConfigurationProto } from "../gen_proto/googleplay_pb";

export interface DeviceInfo {
    build: Partial<AndroidBuildProto>;
    deviceFeatures: DeviceFeature[];
    libraries: string[];
    locales: string[];
    glExtensions: string[];
    userAgent: string;
    authUserAgent: string;
    simOperator?: string;
    versionRelease: number;
    platforms: string[];
    cellOperator?: string;
    roaming?: string;
    timeZone?: string;
    touchScreen: number;
    keyboard: number;
    navigation: number;
    screenLayout: number;
    screen: {
        density: number;
        width: number;
        height: number;
    };
    glVersion: number;
    generateAndroidCheckInRequest(): AndroidCheckinRequest;
    getDeviceConfigProto(): DeviceConfigurationProto;
}

export interface DeviceFeature {
    name: string;
    value: number;
}

export interface Library {
    name: string;
    version: string;
}

export interface DeviceScreen {
    density: number;
    width: number;
    height: number;
}

export interface DeviceBuild extends Partial<AndroidBuildProto> {
    timestamp?: bigint;
}